import React, { useContext } from "react"

import { useTranslation } from "react-i18next"

import { FlowContext } from "../../providers/Tablet/RegistrationFlowProvider"
import { isNative } from "../../utils"

import { useAppSelector } from "../../redux/reducers"
import { selectVisitorRegistration } from "../../redux/visitor_registration/selectors"

import VisitorContent from "../../components/Visitors/VisitorContent"
import VisitorFooter from "../../components/Visitors/VisitorFooter"
import VisitorHeader from "../../components/Visitors/VisitorHeader"
import VisitorView from "../../components/Visitors/VisitorView"
import Button from "../../components/basic/Button"

const DocumentInfo = () => {
	const { t } = useTranslation()

	const { nextStep, previousStep } = useContext(FlowContext)

	const { data, isLoading } = useAppSelector(selectVisitorRegistration)

	const handleContinue = () => nextStep()

	const handleGoBack = () => previousStep()

	return (
		<VisitorView>
			<VisitorHeader showNavigation={!isNative()} />
			<VisitorContent>
				<div className="subtitle">
					{t("tablet.visitors.screens.document.read")}
				</div>
				<div className="info">
					{data?.document?.required_signing
						? t("tablet.visitors.screens.document.read_sign")
						: t("tablet.visitors.screens.document.only_read")}
				</div>
			</VisitorContent>
			<VisitorFooter>
				<div>
					<Button onClick={handleContinue} isLoading={isLoading}>
						{t("tablet.visitors.continue")}
					</Button>
				</div>
				{isNative() && (
					<div>
						<Button
							variant="link"
							onClick={handleGoBack}
							isDisabled={isLoading}
						>
							{t("general.redirection.go_back")}
						</Button>
					</div>
				)}
			</VisitorFooter>
		</VisitorView>
	)
}

export default DocumentInfo
